﻿import { FIQAssist } from "../app";
import {Component, Attribute, Input, Output, Inject} from '@fiqas/angular-utils';
import { KeyCodes, KeyboardEventCode } from "@fiqas/utils"

@Component({
    module: FIQAssist,
    selector: 'pushbutton',
    transclude: true,
    template: `<div tabindex="0" class="pushbutton" ng-class="{isdisabled:$ctrl.isdisabled}" ng-click="$ctrl.onClick($event)" ng-keydown="$ctrl.onKey($event)">
                <span class="centered">
                    <span ng-show="$ctrl.arrow =='left'" class="icon-ArrowLeft"></span>
                    <span ng-show="$ctrl.indicatorColor" ng-style="$ctrl.indicatorStyle" class="indicator-sphere"></span>
                    <span class="buttontext {{$ctrl.arrow}}">{{$ctrl.buttontext}}</span>
                    <span ng-show="$ctrl.arrow =='right'" class="icon-ArrowRight"></span>
                    <span ng-transclude></span>
                </span>
              </div>`
})
export class Pushbutton {
    @Input() public isdisabled: boolean;

    @Attribute() public indicatorColor: string;
    @Attribute() public buttontext: string;
    @Attribute() public link: string;
    @Attribute() public arrow: 'none' | 'left' | 'right';

    @Output()
    public onclicked: () => void;

    public get indicatorStyle() {
        return this.indicatorColor ? { 'background-color': this.indicatorColor } : {};
    }

    constructor(
        @Inject('$transclude') $transclude: angular.ITranscludeFunction
    ) {

    }

    public onClick(event: Event) {
        if (this.isdisabled !== true)
            this.onclicked();
    }

    public onKey(event: KeyboardEvent) {
        if ((event.keyCode == KeyCodes.enter || event.code == KeyboardEventCode.enter) && !this.isdisabled) {
            event.preventDefault();
            this.onclicked();
        }
    }
}
